module.exports = __webpack_public_path__ + "static/media/Rec-3-04.7de157cb.webp";